import { Icon } from 'common/icon';
import { usePostByIdQuery } from 'hooks/api/blog_post';

import styles from './styles.module.css';
import Link from 'next/link';
import { Routes } from 'constants/routes';
import { getItemIdentifier } from 'utils/slug';
import { Analytics } from 'constants/analytics';

type Props = {
  id: string;
};

export const GuideItem = ({ id }: Props) => {
  const { data, isFetching, isError } = usePostByIdQuery({ id });

  if (isFetching) {
    return null;
  }

  if (isError || !data?._id) {
    return (
      <Link
        id={Analytics.collections.guide}
        href={Routes.guides}
        className={styles.container}
      >
        <Icon.Guide />
        <span className={styles.text}>View all guides</span>
        <Icon.Arrow />
      </Link>
    );
  }

  const href =
    data.type === 'guide'
      ? Routes.guidePage(getItemIdentifier(data))
      : Routes.blogAndNewsPage(getItemIdentifier(data));

  return (
    <Link
      id={Analytics.collections.guide}
      href={href}
      className={styles.container}
    >
      <Icon.Guide />
      <span className={styles.text}>{data.title}</span>
      <Icon.Arrow />
    </Link>
  );
};
